export enum AUTHENTICATION_SDK_METHODS {
    // GET_CURRENT_TOKEN_INFO = "getCurrentTokenInfo",
    AUTHENTICATE_CUSTOMER = "authenticateCustomer",
    LOGOUT_CUSTOMER = "logoutCustomer",
}
